import { IUserOrGroup } from "./api/ContentAudience";
import { ResourcePermission } from "./orgSettings";

export enum AudienceModalState {
    TotalAudience = "TotalAudience",
    EditAudience = "EditAudience",
    AddAudience = "AddAudience",
    ResetAudience = "ResetAudience",
    ViewParents = "ViewParents"
}

export enum ResetAudienceOption {
    SyncWithParent = "SyncWithParent",
    RemoveAll = "RemoveAll"
}

export interface IAssignRoleControl  {
    userOrGroup: IUserOrGroup,
    addToRecentlyAdded: (userOrGroup: IUserOrGroup, permission: ResourcePermission) => void,
    removeRecentlyAdded: (userOrGroup: IUserOrGroup) => void,
}

export type AddOrEditModalStateOnly = AudienceModalState.AddAudience | AudienceModalState.EditAudience


export interface IContentAudienceModalProfilePics {
    name: string, 
    profilePics:string[], 
    cap:number, 
    type: string, 
    hasNoUsers?:boolean, 
    isExternallyManaged?:boolean, 
    externalLoginIconUrl?: string
}